import {orderBy} from 'lodash'
import React from 'react'
import ListBox from '../listbox'
import {Consumer} from '../../context'

export default function SelectGroup(props) {

  const {selectedGroup, onClick} = props

  return (<Consumer>{ context => {

    const groups = context.groups.map(group => {
      return {
        ...group,
        selected: (group.id == selectedGroup.id)
      }
    })

    return (
      <ListBox
        className= "select-group"
        labelId= "group_label"
        items= {orderBy(groups, ['course'])}
        onClick = {onClick}
        />)
  }}</Consumer>)
}
